const slugify = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const Mockup = ({ label, caption, src, position = "center", className = "" }) => (
  <figure className={className} data-testid={`mockup-${slugify(label)}`}>
    <div className="relative aspect-[16/10] overflow-hidden rounded-xl border border-slate-700/60 bg-[#0b1322] shadow-[0_28px_70px_-28px_rgba(11,19,34,0.6)]">
      {src ? (
        <img
          src={src}
          alt={label}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-contain"
          style={{ objectPosition: position }}
        />
      ) : (
        <>
      <div className="absolute inset-0 grid-faint-dark" />
      <div className="absolute -top-28 left-1/2 h-72 w-[130%] -translate-x-1/2 rounded-full bg-[#b91c1c]/20 blur-3xl" />
      <svg
        className="absolute bottom-6 left-6 h-16 w-40 opacity-40"
        viewBox="0 0 160 60"
        fill="none"
        aria-hidden="true"
      >
        <polyline
          points="0,48 24,40 48,44 72,26 96,30 120,14 144,18 160,6"
          stroke="#b91c1c"
          strokeWidth="1.5"
        />
        {[0, 24, 48, 72, 96, 120, 144, 160].map((x, i) => (
          <circle key={i} cx={x} cy={[48, 40, 44, 26, 30, 14, 18, 6][i]} r="2" fill="#b91c1c" />
        ))}
      </svg>
      <div className="absolute right-6 top-6 hidden gap-1.5 sm:flex" aria-hidden="true">
        <span className="h-2 w-2 rounded-full bg-[#f97316]/70" />
        <span className="h-2 w-2 rounded-full bg-[#16a34a]/70" />
        <span className="h-2 w-2 rounded-full bg-[#b91c1c]/70" />
      </div>
      <span className="absolute left-5 top-5 h-3 w-3 border-l border-t border-slate-500/70" aria-hidden="true" />
      <span className="absolute bottom-5 right-5 h-3 w-3 border-b border-r border-slate-500/70" aria-hidden="true" />
      <div className="absolute inset-0 flex items-center justify-center px-6">
        <span className="rounded border border-dashed border-slate-500/70 bg-white/[0.04] px-4 py-2 text-center font-mono-data text-[11px] uppercase tracking-[0.18em] text-slate-300">
          {label}
        </span>
      </div>
        </>
      )}
    </div>
    {caption && <figcaption className="mt-3 text-sm leading-relaxed text-slate-500">{caption}</figcaption>}
  </figure>
);
